import { render, staticRenderFns } from "./EditMailDestination.vue?vue&type=template&id=462a62d9&scoped=true&"
import script from "./EditMailDestination.vue?vue&type=script&lang=js&"
export * from "./EditMailDestination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462a62d9",
  null
  
)

export default component.exports